<template>
  <div>
    <ul class="grid grid-cols-4 gap-x-16 gap-y-12">
      <li
        v-for="(link, index) in links"
        v-show="index < maxVisibleLinks || showAll"
        :key="link.label"
      >
        <a
          class="body-2 transition-colors hover:text-action-default-hi"
          :href="link.url"
          @click.prevent="emit('link-click', link.url)"
        >
          {{ link.label }}
        </a>
      </li>
      <li v-if="!showAll && links.length > maxVisibleLinks">
        <button
          class="body-2-bold transition-colors hover:text-static-default-hi"
          type="button"
          @click="showAll = true"
        >
          {{ seeMoreLabel }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { SeoLink } from './SeoFooterLinks.types'

withDefaults(
  defineProps<{
    links: SeoLink[]
    seeMoreLabel?: string
    maxVisibleLinks?: number
  }>(),
  {
    seeMoreLabel: 'See more',
    maxVisibleLinks: 39,
  },
)

const emit = defineEmits<{
  (e: 'link-click', label: string): void
}>()

const showAll = ref(false)
</script>
